var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { RuntimeSchedule } from './RuntimeSchedule';
import { bound } from '../../../../utils/decorators/basic';
export class RuntimeScheduleNextState extends RuntimeSchedule {
    latestRun;
    async addToNext(actionFunc, options = {}) {
        const task = this.addTask(actionFunc, options);
        if (!task)
            return;
        this.triggerNextStateChange();
        return await task.promise;
    }
    nextTimer;
    triggerNextStateChange() {
        if (typeof this.nextTimer === 'undefined') {
            this.nextTimer = setTimeout(this.processNextStateChange, 20);
        }
    }
    processNextStateChange() {
        this.nextTimer = undefined;
        return super.processCurrentBatch();
    }
}
__decorate([
    bound
], RuntimeScheduleNextState.prototype, "triggerNextStateChange", null);
__decorate([
    bound
], RuntimeScheduleNextState.prototype, "processNextStateChange", null);
